import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import dayjs from './plugins/dayjs';
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "@/firebaseConfig";
 
loadFonts()
let appInitialized = false;

onAuthStateChanged(auth, async (user) => {
  await new Promise((resolve) => setTimeout(resolve, 1500)); // simulate delay

  if (user) {
     store.dispatch("startUserListener", user.uid);
     store.dispatch("startApplicationRestartListener");
  } 

  if (!appInitialized) {
    createApp(App)
      .use(store)
      .use(router)
      .use(vuetify)
      .use(autoAnimatePlugin)
      .mount("#app");
    appInitialized = true;
  }
});